import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  font-size: 20px;

  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[40]};

  svg {
    color: ${({ theme }) => theme.colors.heading};
  }

  h1 {
    font-weight: 600;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.heading};
  }

  @media (max-width: 600px) {
    align-items: flex-start;
    gap: 8px;
    font-size: 18px;

    h1 {
      min-width: 0;
      font-size: 18px;
      overflow-wrap: anywhere;
    }

    svg {
      flex-shrink: 0;
    }
  }
`;
